import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { HttpClientModule } from '@angular/common/http';
import { ngxsImports } from './core/store';
import { provideIonicAngular } from "@ionic/angular/standalone";
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

export const appConfig: ApplicationConfig = {
  providers: [importProvidersFrom(HttpClientModule, ngxsImports, NgxDaterangepickerMd.forRoot()), provideRouter(routes), provideIonicAngular()]
};
